import { Bounds, Vector } from '@ardoq/graph';
import { BlocksReference } from '../types';

import {
  AQBLOCKS_DROPSHADOW_FILL,
  AQBLOCKS_DROPSHADOW_OFFSET,
  AQBLOCKS_HANDLE_FILL,
  AQBLOCKS_HANDLE_SIZE,
  AQBLOCKS_HANDLE_STROKE,
} from '../consts';
import { RenderParameters } from './types';

export const renderReferenceHandles = (
  _reference: BlocksReference,
  _bounds: Bounds,
  route: Vector[],
  params: RenderParameters
) => {
  const pixel = 1;
  const sz = Math.ceil(AQBLOCKS_HANDLE_SIZE / 2);

  const renderHandle = (vector: Vector) => {
    /* drop shadow */
    params.ctx.fillStyle = AQBLOCKS_DROPSHADOW_FILL;
    params.ctx.fillRect(
      vector[0] - sz + AQBLOCKS_DROPSHADOW_OFFSET,
      vector[1] - sz + AQBLOCKS_DROPSHADOW_OFFSET,
      1 + 2 * sz,
      1 + 2 * sz
    );

    /* handle */
    params.ctx.fillStyle = AQBLOCKS_HANDLE_FILL;
    params.ctx.strokeStyle = AQBLOCKS_HANDLE_STROKE;
    params.ctx.fillRect(vector[0] - sz, vector[1] - sz, 1 + 2 * sz, 1 + 2 * sz);
    params.ctx.strokeRect(
      vector[0] - sz,
      vector[1] - sz,
      1 + 2 * sz,
      1 + 2 * sz
    );
  };

  if (route) {
    params.ctx.lineWidth = 1 * pixel;

    for (const pt of route) {
      renderHandle(params.projection.projectPointSnapped(pt));
    }
  }
};
